import React from 'react'
import { Box, Text } from '@fundamentals'
import { Button, Card, Divider } from '@common/material'
import { CardContent } from '@mui/material'
import { localizedStrings } from '@core/strings'
import { Section } from '@common/Section'
import { TemplateQuestionGroup } from '@core/entities/template/TemplateQuestionGroup'
import { LinkedChecklistResult } from '@core/entities/linkedProcesses/LinkedChecklistResult/LinkedChecklistResult'
import { useRouter } from 'next/router'
import { PageUrls } from '@core/page-urls'
import { useProductAccess } from 'webapp/providers/authentication'

type TaskInspectionCardProps = {
  checklistQuestionGroup: TemplateQuestionGroup
  checklist: LinkedChecklistResult
}

export const TaskInspectionCard: React.FC<TaskInspectionCardProps> = ({
  checklistQuestionGroup,
  checklist,
}) => {
  const { isViewMode } = useProductAccess()
  const router = useRouter()
  const questionTitle = checklistQuestionGroup?.title
  const questionBody = checklistQuestionGroup?.data?.[0]?.body

  return (
    <Card>
      <CardContent sx={{ pb: 0, '&:last-child': { pb: isViewMode ? 1 : 3 } }}>
        <Text
          showTooltip
          sx={{ fontSize: '16px' }}
          variant='h6'
          color='text.primary'
          gutterBottom
        >
          {localizedStrings.inspection}
        </Text>
        <Divider />

        <Text showTooltip my={2}>
          {checklist?.template.getTemplateName()}
        </Text>

        <Section label={questionTitle} mt={2}>
          <Box
            dangerouslySetInnerHTML={{
              __html: questionBody,
            }}
          />
        </Section>
      </CardContent>
      {!isViewMode && (
        <Button
          variant='text'
          sx={{ ml: 1, mb: 1 }}
          onClick={() => {
            const organisationId = checklist?.organisationId
            const projectId = checklist?.project?.id
            const checklistId = checklist?.id
            const inspectionUrl = projectId
              ? PageUrls.projectInspection({
                  organisationId,
                  projectId,
                  checklistId,
                })
              : PageUrls.inspection(organisationId, checklistId)
            router.push(inspectionUrl)
          }}
        >
          {localizedStrings.openInspection}
        </Button>
      )}
    </Card>
  )
}
